import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot } from '@angular/router';
import { UserSessionService } from '@app/services/user-session.service';
import { Level } from '@data/models/role.model';

@Injectable()
export class UserSessionGuard implements CanActivate {

    constructor(
        private userSessionService: UserSessionService,
    ) { }

    public async canActivate(route: ActivatedRouteSnapshot): Promise<boolean> {
        const currentUser = this.userSessionService.getUserSession() || await this.userSessionService.initSession();

        // No specific acl on this route > Accept
        if (!route.data.acl) {
            return true;
        }

        // No user rights > Reject
        if (!currentUser.maxLevelByEntities) {
            return false;
        }

        // Take the strongest route level if omitted
        const requiredLevel = route.data.acl.level ?
            route.data.acl.level :
            Level.ADMIN;

        // Take the weakest user level if omitted
        const userLevel = currentUser.maxLevelByEntities[route.data.acl.entity] ?
            currentUser.maxLevelByEntities[route.data.acl.entity] :
            Level.READ;

        return !(
            (requiredLevel === Level.EDIT && userLevel === Level.READ) ||
            (requiredLevel === Level.ADMIN && userLevel !== Level.ADMIN)
        );
    }
}
